import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, ListGroup, Image, Spinner } from "react-bootstrap";
import { toast } from "react-toastify"; // 🔔 For user notifications
import { useSelector, useDispatch } from "react-redux";
import { getMyOrders } from "../../../redux/orderSlice";
import { submitRating } from "../../../redux/productSlice";
import StarRating from "../../common/StarRating/StarRating";
import ReviewModal from "../../common/ReviewModal/ReviewModal";
import { loggedUser } from "../../../redux/authSlice";
import RatingForm from "../../common/RatingForm/RatingForm";
import RatingStar from "../../common/RatingStar/RatingStar";
import { current } from "@reduxjs/toolkit";

const Order = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { orders, loading, error } = useSelector((state) => state.order);
  const [rating, setRating] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [currentRating, setCurrentRating] = useState(null);
  console.log("user++++", user);
  console.log("selectedProduct", selectedProduct);

  // const userInfo = async () => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     if (!token) {
  //       navigate("/");
  //       return;
  //     }
  //     if (user) {
  //       await dispatch(loggedUser(token)).then(() => {
  //         dispatch(getMyOrders());
  //       });
  //     }
  //     else {
  //       navigate("/");
  //     }
  //   } catch (error) {
  //     toast.error(error.message || "An error occurred");
  //   }
  // };



  // Handle token authentication
  // useEffect(() => {
  //   if (user) userInfo();
  //   dispatch(getMyOrders()).then((res) => {
  //     if (res.payload?.error) {
  //       toast.error(res.payload.error === "Invalid or expired token" ? "Please login again" : res.payload.error);
  //       localStorage.removeItem("token");
  //       localStorage.removeItem("user");
  //       localStorage.removeItem("role");
  //       navigate("/login");
  //     }
  //   })
  // }, [dispatch, navigate]);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchData = async () => {
      try {
        await dispatch(loggedUser(token));
        const res = await dispatch(getMyOrders());
        if (res.payload?.error) {
          toast.error(res.payload.error === "Invalid or expired token" ? "Please login again" : res.payload.error);
          localStorage.clear();
          navigate("/login");
        }
      } catch (error) {
        toast.error("Something went wrong");
      }
    };

    fetchData();
  }, [dispatch, navigate]);
  const handleRatingChange = (rating, productID, orderID) => {
    console.log("Selected rating order:", rating, productID, orderID);
    dispatch(submitRating({ productId: productID, orderId: orderID, rating })).then((response) => {
      if (response.payload.error) {
        toast.error(response.payload.message);
      } else {
        toast.success(response.payload.message === "Rating submitted" ? "Thank you for rating" : response.payload.message);
      }
    }).then(() => {
      dispatch(getMyOrders())
    });
  };


  if (loading) return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
      <Spinner animation="border" />
    </div>
  );
  { error && <p className="text-center text-danger">{error}</p> }

  return (
    <Container className="mt-5">
      <h2 className="mb-4 text-center">Your Orders ({orders?.length || 0})</h2>

      {orders?.length === 0 ? (
        <p className="text-center">Your order is empty.</p>
      ) : (
        <Row>
          {/* Sidebar */}
          <Col md={4}>
            <Card className="p-3 shadow-sm">
              <Link to="/my/profile" className="text-decoration-none">Profile</Link>
              <Link to="/my/orders" className="text-decoration-none">Orders</Link>
            </Card>
          </Col>

          {/* Order List */}
          <Col md={8}>
            <ListGroup>
              {orders?.map((order) => (
                <Card key={order._id} className="mb-4 shadow-sm">
                  <Card.Header>
                    {/* <p><strong>Order ID:</strong> {order._id}</p> */}
                    <p><strong>Order Number:</strong> {`HHM-${order?.orderNumber}`}</p>
                    <p>
                      {order.status} <span>On {new Date(order.orderDate).toLocaleDateString('en-IN', {
                        year: 'numeric', month: 'long', day: 'numeric'
                      })}</span>
                    </p>
                  </Card.Header>

                  {order?.products?.map((item) => (

                    <ListGroup.Item key={item?._id} className="d-flex align-items-center">
                      {/* Product Image */}
                      <Image
                        src={`${apiUrl}${item?.product?.images?.[0]}` || "https://via.placeholder.com/100"}
                        alt={item?.product?.name}
                        width={100}
                        className="rounded me-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(`/product/${item?.product?.slug}`)}
                      // onClick={() => navigate(`/product/${item?.product?._id}`)}
                      />

                      <div className="flex-grow-1">
                        <h5>{item?.product?.name}</h5>
                        {/* <h5>{item?.product?._id}</h5> */}
                        <p>Price: ₹{item?.product?.price}</p>
                        <p>Description: {item?.product?.description}</p>
                        <p>Quantity: {item?.quantity}</p>
                        {order?.discount !== 0 && (
                          <>
                            <p>Discount: {order?.discount}</p>
                            <p>Total Amount: {order?.finalAmount}</p>
                            <p>Coupon Code: {order?.couponCode}</p>
                            <p>Final Amount: {order?.finalAmount}</p>
                          </>
                        )}

                        {/* Star Rating */}
                        <div>
                          <p>
                            <strong>Rating:</strong>
                          </p>
                          <RatingStar
                            initialRating={item?.product?.ratings?.find((r) => r.userId === user?._id)?.rating || 0}
                            onRatingChange={(rating = initialRating) => handleRatingChange(rating, item?.product?._id, order?._id)} />
                          {/* <StarRating maxRating={5} size={24} onSetRating={(ratingValue) => setRating(ratingValue)} /> */}
                        </div>

                        {/* Write Review Button */}
                        <Button
                          variant="danger"
                          onClick={() => {
                            console.log(rating)
                            if (item?.product?.ratings.find((r) => r.userId === user?._id)?.rating === 0) {
                              toast.error("Please select a rating first.");
                              return;
                            }
                            setSelectedProduct(item.product);
                            setCurrentRating(() => item?.product?.ratings.find((r) => r.userId === user?._id)?.rating || 0);
                            setShowModal(true);
                            setOrderId(order._id)
                            // dispatch(addRating({ rating, productId: item.product._id, userId: user._id }));
                          }}
                        >
                          Write Review
                        </Button>

                      </div>
                    </ListGroup.Item>
                  ))}

                  <Card.Footer>
                    {order?.discount === 0 ?
                      (<h5 className="mb-0 text-end">
                        <strong>Payment:</strong> {order.paymentMethod} | Total: ₹{order.totalAmount.toFixed(2)}
                      </h5>)
                      : (<h5 className="mb-0 text-end">
                        <strong>Payment:</strong> {order.paymentMethod} | Total: ₹{order?.finalAmount}
                      </h5>)
                    }
                  </Card.Footer>
                </Card>
              ))}
            </ListGroup>
          </Col>
        </Row >
      )
      }

      {/* Review Modal (Only Opens for Selected Product) */}
      {
        selectedProduct && (
          <ReviewModal
            show={showModal}
            handleClose={() => setShowModal(false)}
            product={selectedProduct}
            userId={user?._id}
            orderId={orderId}
            currentRating={currentRating}
          />
        )
      }
    </Container >
  );
};

export default Order;

